import { ASSESSMENT_METHODOLOGY_VERSION, SESSION_STORAGE_ENABLED, SESSION_STORAGE_KEY } from '../../config/assessmentConfig'
import { createInitialState } from './engine'
import type { AssessmentState } from './types'

export function loadAssessmentState(): AssessmentState {
  if (!SESSION_STORAGE_ENABLED || typeof sessionStorage === 'undefined') {
    return createInitialState()
  }
  try {
    const raw = sessionStorage.getItem(SESSION_STORAGE_KEY)
    if (!raw) return createInitialState()
    const parsed = JSON.parse(raw) as AssessmentState
    if (parsed.methodologyVersion !== ASSESSMENT_METHODOLOGY_VERSION) {
      return createInitialState()
    }
    return {
      ...createInitialState(),
      ...parsed,
      companyProfile: { ...createInitialState().companyProfile, ...parsed.companyProfile },
    }
  } catch {
    return createInitialState()
  }
}

export function saveAssessmentState(state: AssessmentState): void {
  if (!SESSION_STORAGE_ENABLED || typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(state))
  } catch {
    // Quota or private mode — assessment still works in memory for the page session.
  }
}

export function clearAssessmentState(): void {
  if (typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.removeItem(SESSION_STORAGE_KEY)
  } catch {
    // ignore
  }
}
